import type { UserGroup } from '@gmn-portal/backend';
import { useQuery } from '@tanstack/react-query';

import { payloadClient } from '.';
import type { FindPayloadApiClientParams } from './types';

export type UserGroupQueryParams = FindPayloadApiClientParams<'user-groups', UserGroup> & {
  disabled?: boolean;
};

export const userGroupKeys = {
  all: ['user-groups'] as const,
  lists: () => [...userGroupKeys.all, 'list'] as const,
  list: (params: UserGroupQueryParams) => [...userGroupKeys.lists(), params] as const,
  details: () => [...userGroupKeys.all, 'detail'] as const,
  detail: (id: string) => [...userGroupKeys.details(), id] as const,
} as const;

export const useUserGroups = (params?: UserGroupQueryParams) => {
  return useQuery({
    queryKey: userGroupKeys.list(params ?? {}),
    enabled: !params?.disabled,
    queryFn: async () => {
      const response = await payloadClient.find({
        collection: 'user-groups',
        ...(params as FindPayloadApiClientParams<'user-groups', UserGroup>),
      });
      return response;
    },
  });
};

export const useUserGroup = (id: string, params?: { disabled?: boolean }) => {
  return useQuery({
    queryKey: userGroupKeys.detail(id),
    enabled: !params?.disabled && !!id,
    queryFn: async () => {
      const response = await payloadClient.findById({
        collection: 'user-groups',
        id,
      });
      return response;
    },
  });
};
